<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item>{{article['title']}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-title">
        {{article['title']}} <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
      </div>
      <div class="toolbar">
        <el-button circle @click="handle_print"><i class="fas fa-print"></i></el-button>
  
        <social-sharing 
          :url="`${APP}/article/${article['system_id']}`" 
          inline-template
          v-for="(brand, idx) in social_shares"
          :key="idx"
          class="social-sharing"
        >
            <network :network="brand">
              <i :class="`fab fa-${brand}`"></i> {{brand}}
            </network>
        </social-sharing>
      </div>
      <div class="page-content page-content--2cols reverse-2cols">
        <div class="page-content-left">
          <EditViewForm 
            :page_structure="page_structure"
            :preloaded_data="article"
            mode="view"
            :no_show_empty="true"
          />
          <div class="page-sub-title">
            相關資料
          </div>
          <ul class="data-list data-list--normal">
            <li class="data-item"
              v-for="(article, idx) in related_articles"
              :key="idx"
            >
              <div class="image"><img
                  :src="`${APP}/${article['cover_image_path']}`"
                  alt=""></div>
              <a :href="`/article/${article['system_id']}`" class="title">{{article['title']}}</a>
              <div v-for="(keyword, idx) in article['keywords']" :key="idx" class="cat1">{{keyword}}</div>
            </li>
          </ul>
        </div>
        <div class="page-content-right">
          <div class="page-content-box">
            <div class="page-content-title">
              <span><i class="fas fa-image"></i> 相關照片</span>
            </div>
            <div class="attach-images">
              <hooper :settings="hooperDetailAttachImageSettings"
                v-if="article_do_list.length > 0"
                @slide="handle_show_picture_description"
              >
                <slide
                  v-for="(digital_object, idx) in article_do_list"
                  :key="idx"
                  :index="idx"
                >
                  <a :href="`${APP}/${digital_object['preview_image_url_800']}`" target="_blank">
                    <img
                      :src="`${APP}/${digital_object['preview_image_url_150']}`"
                      :alt="digital_object['description']">
                  </a>
                </slide>
                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>
            <div>{{image_description}}</div>
          </div>
          <div class="page-content-box">
            <div class="page-content-title">
              <span><i class="fas fa-filter"></i> 其他館藏資源</span>
            </div>
            <ul class="links">
              <li
                v-for="(link, idx) in collection_links"
                :key="idx"
              >
                <a @click="()=>handle_link_clicked(link)">
                  <span class="link">{{link.title}}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination
  } from 'hooper';
  import 'hooper/dist/hooper.css';
  import api from '@/api/frontstage'
  import PageStructure from '@/views/backstage/structure/detail_page/DetailPageStructure'
  import printPageMixin from '@/mixins/printPageMixin'
  import frontstageSearchMixin from '@/mixins/frontstageSearchMixin'
  import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'

  export default {
    name: 'article',
    metaInfo () {
      return {
        meta: [
          {
            property:"og:description",
            content: this.article['title']
          },
          {
            property:"og:image",
            content: this.article_do_list.length > 0? `${this.APP}/${this.article_do_list[0]['preview_image_url_150']}` : ''
          },
        ],
      }
    },
    mixins: [
      printPageMixin,
      frontstageSearchMixin
    ],
    components: {
      HeaderSlide,
      Hooper,
      Slide,
      HooperNavigation,
      HooperPagination,
      EditViewForm
    },
    async created () {
        if (typeof this.$route.params === 'undefined' || typeof this.$route.params.id === 'undefined') {
          return
        }

        let res = await api.get_article(this.$route.params.id)
        if (res.success !== true) {
            this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得文章', res.message)
            return
        }

        console.log('[前臺] article: ', res)
        this.page_structure = PageStructure(res['payload']['payload']['series_table_name'], 'frontstage')
        this.$set(this, 'article', this.translate_to_display_data(this.page_structure, res['payload']['payload']))

        res = await api.get_article_do_list(this.$route.params.id)
        if (res.success) {
            console.log('[前臺] article do list: ', res)
            this.article_do_list = res['payload']['payload']['search_result']
            this.image_description = res['payload']['payload']['search_result'][0]['description']  == 'null' ? '' : res['payload']['payload']['search_result'][0]['description']
        }
        else {
            this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得文章數位物件列表', res.message)
            return
        }

        res = await api.get_article_list({
          "fk_folder_id":{
            "value": this.article['fk_folder_id'],
            "action":"="
          },
        })
        if (res.success) {
            console.log('[前臺] related article list: ', res)
            res['payload']['payload']['search_result'].forEach(function (article) {
              article['keywords'] = article['keywords'].split(';')
              if (article['cover_image'][0] && article['cover_image'][0]['path']) {
                  article['cover_image_path'] = article['cover_image'][0]['path']
              }
              else {
                  article['cover_image_path'] = null
              }
            })
            this.related_articles = res['payload']['payload']['search_result']
        }
        else {
            this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得相關文章列表', res.message)
            return
        }
    },
    data() {
      return {
        APP: process.env.VUE_APP_URL,
        hooperDetailAttachImageSettings: {
          autoPlay: false,
          playSpeed: 5000,
          transition: 1000,
          infiniteScroll: false,
          wheelControl: false,
        },
        article: {},
        article_do_list: [],
        related_articles: [],
        page_structure: [],
        // social_shares: ['facebook','linkedin','twitter','pinterest'],
        social_shares: ['facebook'], // 改成只留facebook
        image_description: ''
      }
    },
    methods: {
      handle_print() {
        //this.do_print(this.page_structure, this.article)
        window.print()
      },

      handle_link_clicked (link) {
        this.update_frontstage_filter_series_number(link['series_number'])
        this.$router.push({ path: '/collection'})
      },

      handle_show_picture_description(current){
        let choose_picture = current.currentSlide
        console.log(this.article_do_list[choose_picture]['description'])
        this.image_description = this.article_do_list[choose_picture]['description'] == 'null' ? '' : this.article_do_list[choose_picture]['description']
      }
    }
  }
</script>
<style lang="scss" scoped>
  .toolbar {
    margin-bottom: 16px;
    /deep/.el-button {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      padding: 0;
    }
  }

  .social-sharing {
    margin-left: 11px;
    cursor: pointer;
  }

  .link {
    margin-left: 11px;
    cursor: pointer;
  }

  .accesskey-content{
    color: white;
  }
</style>
